import { render } from "./TaskSearchFilters.vue?vue&type=template&id=ad3a8900"
import script from "./TaskSearchFilters.vue?vue&type=script&lang=js"
export * from "./TaskSearchFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__